import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import DashComp from './DashComp'

function Dashboard() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <DashComp/>      
        </div>
    </div>
  )
}

export default Dashboard